var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"responsive-video tw-relative tw-h-full",class:[_vm.full_width ? 'tw-w-full' : 'tw-w-9/12 tw-mx-4'],attrs:{"id":"screen-video-player"}},[_c('video',{ref:"video",staticClass:"max-vh-vw",attrs:{"muted":""},domProps:{"muted":true}}),_c('audio',{ref:"audio",staticStyle:{"display":"none"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }